import { render } from "./ErrorFallback.vue?vue&type=template&id=5aa87036&scoped=true"
import script from "./ErrorFallback.vue?vue&type=script&lang=js"
export * from "./ErrorFallback.vue?vue&type=script&lang=js"

import "./ErrorFallback.vue?vue&type=style&index=0&id=5aa87036&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aa87036"]])

export default __exports__